import React from "react";
import ComingSoon from "../../components/ComingSoon";

const WorkflowConfig = () => {
  return (
    <ComingSoon
      title="Workflow Configuration"
      description="Configure and customize business workflows for ESG processes and approvals."
      icon="⚙️"
    />
  );
};

export default WorkflowConfig; 